import { PagerProps } from '@progress/kendo-react-data-tools'
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import { NumericTextBox } from '@progress/kendo-react-inputs'
import { useDashboardContext } from '../../Context/DashboardContext'
import style from './GridComponentsStyle.module.scss'

export const CustomPager = (
    props: PagerProps,
    handleTakeChange: (event: DropDownListChangeEvent) => void
) => {
    const totalPages = Math.ceil((props.total || 0) / props.take)
    const { appState, setAppState, currentPage, setCurrentPage } = useDashboardContext()
    const handleChange = (e: any) => {
        if (props.onPageChange) {
            setCurrentPage(((e.value - 1) * props.take) / props.take + 1)
            appState.skip = (e.value - 1) * props.take
            setAppState(appState)
            props.onPageChange({
                target: e.target,
                skip: (e.value - 1) * props.take,
                take: props.take,
                syntheticEvent: e,
                nativeEvent: e.nativeEvent,
            })
        }
    }
    return (
        <div
            className={'k-pager k-pager-md k-grid-pager'}
            style={{
                borderTop: '1px solid',
                borderTopColor: 'inherit',
                backgroundColor: '#ebf0fa',
            }}
        >
            <div className="col-4" style={{ display: 'inline-block' }}>
                <div style={{ margin: '.5em' }}>
                    <NumericTextBox
                        value={currentPage}
                        onChange={handleChange}
                        min={1}
                        max={totalPages}
                        width={80}
                        className={style.numericBox}
                    />
                </div>
            </div>
            <div
                className="col-4"
                style={{ display: 'inline-block', marginTop: '1em', marginRight: '2em' }}
            >
                <span>{`Page ${currentPage} of ${totalPages}`}</span>
            </div>
            <div className="col-4" style={{ display: 'inline-block' }}>
                <DropDownList
                    data={[5, 10, 100, props.total]}
                    value={appState.pageSize}
                    onChange={handleTakeChange}
                    style={{ margin: '.5em', width: '80px' }}
                />
                <span style={{ display: 'inline-block' }}>Customers per page</span>
            </div>
        </div>
    )
}
